import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { FormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { HeaderComponent } from './component/header/header.component';
import { HeroComponent } from './component/hero/hero.component';
import { BodyComponent } from './component/body/body.component';
import { Footer1Component } from './component/footer1/footer1.component';

import { DatosService } from './datos.service';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HeroComponent,
    BodyComponent,
    Footer1Component,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    HttpModule,
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule,
    FormsModule,
  ],
  providers: [DatosService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// G:/proyectos/website - IntergraMAI/webMai/src/app/app.module.ts